import { AppType } from "../../constants/AppType";
import { getAppType } from "../../getAppType";
import { useSettings } from "../../settings/useSettings";
import { useBrowserPrefersDarkMode } from "../../utils/style/useMediaQuery";
import { useStorageBackedState } from "../../utils/useStorageBackedState";
import { isAdminPreview } from "./isAdminPreview";

export const useShouldShowDarkMode = () => {
  const settings = useSettings();
  const browserPrefersDarkMode = useBrowserPrefersDarkMode();

  function systemValue() {
    if (settings.theme === "light") {
      return false;
    }
    if (settings.theme === "dark") {
      return true;
    }
    if (settings.theme === "auto") {
      return browserPrefersDarkMode;
    }
  }

  let [darkModeUserPreference, setDarkModeUserPreference] =
    useStorageBackedState<boolean | null>("shouldShowDarkMode", null);

  function shouldShowDarkMode() {
    if (settings.iframe_overrideTheme) {
      return settings.iframe_overrideTheme === "dark";
    }
    if (isAdminPreview()) return systemValue();

    if (getAppType() === AppType.iframe) {
      return systemValue();
    }
    if (darkModeUserPreference !== null) {
      return darkModeUserPreference;
    }
    return systemValue();
  }

  return {
    darkMode: shouldShowDarkMode(),
    setDarkModeUserPreference,
  };
};
